import classNames from 'classnames';
import {Link} from 'gatsby';
import React from 'react';

import {imageUrlBuilder} from '_utils';

interface Props {
  item: Queries.ArticlePreviewInfoFragment;
  mobileSize?: 'small' | 'normal';
}

const ArticlePreview = ({item, mobileSize = 'normal'}: Props) => {
  return (
    <div
      className={classNames(
        'flex-shrink-0 lg:w-[370px]',
        mobileSize === 'small' ? 'w-[340px]' : 'w-full',
      )}>
      <Link to={`/article/${item.slug}`}>
        <div className="rounded-lg w-full overflow-hidden">
          <img
            className="object-cover w-full h-[238px] lg:h-[260px]"
            src={
              item.thumbnail
                ? imageUrlBuilder
                    .image(item.thumbnail)
                    .width(400)
                    .format('webp')
                    .url()
                : undefined
            }
            alt={item.title ?? ''}
          />
        </div>
      </Link>
      <div className="mt-4">
        <Link
          to={`/article/${item.slug}`}
          className="line-clamp-2 text-lg text-gray1 font-bold">
          {item.title}
        </Link>
      </div>
      <Link
        className="mt-1 text-sm text-primary hover:text-dark-blue"
        to={`/articles?categoryId=${item?.category?.id}`}>
        {item?.category?.name}
      </Link>
    </div>
  );
};

export default ArticlePreview;
